export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * 将UTC时间字符串转换为本地日期格式（只保留日期部分）
 * @param utcTimeString UTC时间字符串，如 "2024-01-15T10:30:00Z"
 * @returns 格式化的本地日期字符串，如 "2024/1/15"
 */
export const formatLocalDate = (utcTimeString: string): string => {
  try {
    const date = new Date(utcTimeString)
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return utcTimeString // 如果无法解析，返回原字符串
    }
    
    // 转换为本地日期，只保留年月日
    const year = date.getFullYear()
    const month = date.getMonth() + 1 // getMonth() 返回 0-11
    const day = date.getDate()
    
    return `${year}/${month}/${day}`
  } catch (error) {
    console.warn('日期格式化失败:', error)
    return utcTimeString // 出错时返回原字符串
  }
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Please enter a valid email address'
  },
  required: (v: any) => !!v || 'This field is required',
}
